<template>
  <div id="searchCriteriaSetting" class="page-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>业务设置</el-breadcrumb-item>
      <el-breadcrumb-item>检索标准设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
      <div class="iconDiv">
        .
      </div>
      品牌检索模式设置
    </div>
    <div class="yellowStyle">
      <img src="../../../assets/img/other/trumpet_icon.png" style="margin-right: 5px;">
      <span>
        当前设置的检索模式及参与到手价计算的优惠券，仅在商品库数据更新时生效，模式调整后，需下次更新后生效。
      </span>
    </div>
    <div class="searchCriteriaSettingpage">
      是否开启AI打标
      <el-radio v-model="reportKefuAuditing" label="1" style="margin-left: 20px;" @change="aiChaneg">开</el-radio>
      <el-radio v-model="reportKefuAuditing" label="0" @change="aiChaneg">关</el-radio>
    </div>
    <div class="searchCriteriaSettingpage">
      <el-radio v-model="retrieve" label="0" @change="priceSerch('标价检索', '0')">标价检索</el-radio>
      <el-radio v-model="retrieve" label="1" @change="priceSerch('到手价检索', '1')">到手价检索</el-radio>
      <el-radio v-model="retrieve" label="2" @change="priceSerch('标价&到手价检索', '2')">标价&到手价检索</el-radio>
      <preferentialSettings ref="preferentialSettingsChild" :childRetrieve='childRetrieve'></preferentialSettings>
    </div>

    <div style="font-size: 18px;color: #333333;display: flex;margin: 20px 0 20px 0;">
      <div class="iconDiv">
        .
      </div>
      产品限价标准设置
    </div>
    <div class="yellowStyle">
      <img src="../../../assets/img/other/trumpet_icon.png" style="margin-right: 5px;">
      <span>
        产品限价标准设置后，即刻生效。
      </span>
    </div>
    <div class="searchCriteriaSettingpage">
      <el-radio v-model="limitpricetype" label="0" @change="productPrice('各平台限价相同', limitpricetype)">各平台限价相同</el-radio>
      <el-radio v-model="limitpricetype" label="1" @change="productPrice('各平台限价不同', limitpricetype)">各平台限价不同</el-radio>
    </div>
    <!-- <div class="searchCriteriaSettingpage"> -->
    <!-- 平台限价相同 -->
    <div class="mainBody" v-if="limitpricetype == '0'" v-for="(item, index) in retList">
      <div class="productDiv" @click="showBtn(index, item.id, item.hid)">
        <span style="float: left;">{{ item.product_classify_name }}</span>
        <i class="el-icon-arrow-down" style="margin-left: 8px;" v-if="iShow[index] == true"></i>
        <i class="el-icon-arrow-up" style="margin-left: 8px;" v-else="iShow[index]"></i>
        <span style="margin-left: 20px;" v-if="retrieve == 0 && item.pricenamem">{{ item.pricenamem }}</span>
        <span style="margin-left: 20px;" v-if="retrieve == 1 && item.theirpricenamem">{{ item.theirpricenamem }}</span>
        <span style="margin-left: 20px;"
          v-if="retrieve == 2 && item.pricenamem || retrieve == 2 && item.theirpricenamem">{{ item.pricenamem }}
          {{ item.theirpricenamem }}</span>
        <span style="margin-left: 20px;" v-if="item.retrieveaddtype == 1">
          <i class="el-icon-warning" style="color: #faad14;"></i>
          <span style="font-size: 14px;">
            请重新设置产品限价标准
          </span>
        </span>
        <span style="margin-left: 20px;"
          v-if="item.retrievetype != 1 && retrieve == 0 || item.retrievetype != 1 && retrieve == 2">
          <i class="el-icon-warning" style="color: #faad14;"></i>
          <span style="font-size: 14px;">
            标价限价待设置
          </span>
        </span>
        <span style="margin-left: 20px;"
          v-if="item.retrievetheirpricetype != 1 && retrieve == 1 || item.retrievetheirpricetype != 1 && retrieve == 2">
          <i class="el-icon-warning" style="color: #faad14;"></i>
          <span style="font-size: 14px;">
            到手价限价待设置
          </span>
        </span>
        <el-button type="text" class="qxButton" @click.stop="bjButton(index, item.id, item.hid)"
          v-if="bjShow[index]">编辑</el-button>
        <el-button type="text" class="qxButton" @click.stop="noBjButton(index, item.id, item.hid)"
          v-if="noBjShow[index]">取消</el-button>
        <el-button type="text" style="float: right;" :disabled="disabledSameSave[index] == false"
          @click.stop="sameSave(index, item.id, 0, item.hid, item.pricenamem, item.priceidm)"
          v-if="noBjShow[index]">保存</el-button>
      </div>
      <div class="inputDiv" v-show="entiretyShow[index] == true" style="margin: 20px;">
        <div v-show="retrieve == 0 || retrieve == 2" style="float: left;">
          <span style="color: red;">*</span>
          标价限价
          <el-select size="small" clearable v-model="slimitPrices[index]"
            @change="priceAssignment(slimitPrices[index], index)" :disabled="disabledSelect[index] == false"
            placeholder="请选择" style="margin-top: 10px;width: 190px;margin-left: 15px;margin-right: 60px;">
            <el-option v-for="item in priceData[index]" :key="item.fieldvalue" :value="item.id" :label="item.fieldname"
              v-if="item.isChecked == 1">
            </el-option>
          </el-select>
        </div>
        <div v-show="retrieve == 1 || retrieve == 2" style="float: left;">
          <span style="color: red;">*</span>
          到手价限价
          <el-select size="small" clearable v-model="theirPrices[index]"
            @change="xinPriceAssignment(theirPrices[index], index)" :disabled="disabledSelect[index] == false"
            placeholder="请选择" style="margin-top: 10px;width: 190px;margin-left: 15px;margin-right: 60px;">
            <el-option v-for="item in priceData[index]" :key="item.fieldvalue" :value="item.id" :label="item.fieldname"
              v-if="item.isChecked == 1">
            </el-option>
          </el-select>
        </div>
        <el-checkbox style="margin-top: 15px;" :disabled="disabledSelect[index] == false"
          v-model="checked[index]">允许部分产品限价不同</el-checkbox>
        <el-button v-show="checked[index] == true" :disabled="disabledSelect[index] == false"
          @click="newAdd(index, item.id, item.hid)" type="primary" size="small"
          style="float: right;margin-right: 20px;margin-top: 10px;">新增限价不同的产品</el-button>
        <el-table v-show="checked[index] == true" :data="tableData[index]"
          style="width: calc(100% - 20px);margin-top: 10px;" :show-header="false">
          <el-table-column prop="productname">
          </el-table-column>
          <el-table-column prop="name">
          </el-table-column>
          <el-table-column v-if="retrieve == 0 || retrieve == 2">
            <template slot-scope="scope">
              <div v-if="scope.row.filedname">
                {{ scope.row.filedname }}
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="retrieve == 1 || retrieve == 2">
            <template slot-scope="scope">
              <div v-if="scope.row.filednametheir">
                {{ scope.row.filednametheir }}
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button :disabled="disabledSelect[index] == false"
                @click="compile(index, scope.$index, item.id, item.hid, scope.row.productname, scope.row.productid, scope.row.pricename, scope.row.priceid, scope.row.filedname, scope.row.theirpricename, scope.row.theirpriceid)"
                type="text" size="small">编辑</el-button>
              <el-button :disabled="disabledSelect[index] == false" @click="expurgate(index, scope.$index)" type="text"
                size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 平台限价相同 -->

    <!-- 平台限价不同 -->
    <div class="mainBody" v-if="limitpricetype == '1'" v-for="(item, index) in retList">
      <!-- 限价不同保存/取消↓ -->
      <div class="productDiv" @click="showBtn2(index, item.id, item.hid)">
        <span style="float: left;">{{ item.product_classify_name }}</span>
        <i class="el-icon-arrow-down" style="margin-left: 8px;" v-if="iShow[index] == true"></i>
        <i class="el-icon-arrow-up" style="margin-left: 8px;" v-else="iShow[index]"></i>
        <span style="margin-left: 20px;" v-if="item.retrievetype != 1">
          <i class="el-icon-warning" style="color: #faad14;"></i>
          <span style="font-size: 14px;">
            待设置
          </span>
        </span>
      </div>
      <!-- 限价不同保存/取消↑ -->
      <!-- 内部↓ -->
      <div class="inputDiv2" v-show="entiretyShow[index]">
        <!-- tab切换↓ -->
        <div class="bigTab">
          <div style="margin-left: 20px;">
            <div class="tabStyle" v-for="(item2, n) in retList[index].getRetrievemode" :key="item2.id"
              @mouseenter="stopHover(item.product_classify_name, n)" @mouseleave="leave(item.product_classify_name, n)"
              @click="clickTab(item.product_classify_name, n, 1, index, item.id, item2.id, item2.name, item2.platformcode)">
              {{ item2.name }}
              <span class="iconStyle"
                v-show="iconShow == item.product_classify_name + n || iconShow2 == item.product_classify_name + n"
                @click="removeTab(retList[index].getRetrievemode, index, n, item2.name, item2.platformcode, platform['index' + index + 'n' + n])">
                <i class="el-icon-close"></i>
              </span>
            </div>
            <div class="tabStyle" style="border-right: 1px solid rgba(128, 128, 128, 0.2);"
              @click="addTab(retList[index].getRetrievemode, index)">
              + 添加
            </div>
          </div>
        </div>
        <!-- tab切换↑ -->
        <div style="margin-left: 20px;margin-right: 20px;" v-for="(item2, n) in retList[index].getRetrievemode"
          v-show="situationShow == 'index' + index + 'n' + n">
          <span style="color: red;">*</span>
          平台
          <el-select size="small" :disabled="noDisabledSelect['index' + index + 'n' + n] == false"
            v-model="platform['index' + index + 'n' + n]" @remove-tag="cancelPlatform" multiple placeholder="请选择"
            style="margin-top: 10px;width: 190px;margin-left: 15px;margin-right: 30px;"
            @change="platformScreen(platform['index' + index + 'n' + n], index, n)">
            <el-option v-for="item in plateList[index]" :key="item.dictCode" :value="item.dictCode"
              :label="item.dictName" :disabled="item.suredes == true">
            </el-option>
          </el-select>

          <span style="color: red;" v-show="retrieve == 0 || retrieve == 2">*</span>
          <span style="margin-left: 3px;" v-show="retrieve == 0 || retrieve == 2">标价限价</span>
          <el-select size="small" v-show="retrieve == 0 || retrieve == 2" clearable
            :disabled="noDisabledSelect['index' + index + 'n' + n] == false"
            v-model="slimitPrices2['index' + index + 'n' + n]"
            @change="priceAssignment2(slimitPrices2['index' + index + 'n' + n], index, n)" placeholder="请选择"
            style="margin-top: 10px;width: 190px;margin-left: 15px;margin-right: 60px;">
            <el-option v-for="item in priceData['index' + index + 'n' + n]" :key="item.fieldvalue" :value="item.id"
              :label="item.fieldname">
            </el-option>
          </el-select>

          <span style="color: red;" v-show="retrieve == 1 || retrieve == 2">*</span>
          <span style="margin-left: 3px;" v-show="retrieve == 1 || retrieve == 2">到手价限价</span>
          <el-select size="small" v-show="retrieve == 1 || retrieve == 2" clearable
            :disabled="noDisabledSelect['index' + index + 'n' + n] == false"
            v-model="theirPrices2['index' + index + 'n' + n]"
            @change="xinPriceAssignment2(theirPrices2['index' + index + 'n' + n], index, n)" placeholder="请选择"
            style="margin-top: 10px;width: 190px;margin-left: 15px;margin-right: 60px;">
            <el-option v-for="item in priceData['index' + index + 'n' + n]" :key="item.fieldvalue" :value="item.id"
              :label="item.fieldname">
            </el-option>
          </el-select>

          <el-checkbox v-model="checked2['index' + index + 'n' + n]"
            :disabled="noDisabledSelect['index' + index + 'n' + n] == false"
            @change="noCheckedHits(index, n)">允许部分产品限价不同</el-checkbox>
          <el-button v-if="bjShow['index' + index + 'n' + n]" @click="bjButton2(index, n)" type="primary" size="small"
            style="float: right;margin-right: 20px;margin-top: 10px;">编辑</el-button>
          <span id="dialog">
            <el-button v-if="noBjShow['index' + index + 'n' + n]"
              @click="noBjButton2(index, n, item.product_classify_name, 1, item.id, item2.id, item2.name, item2.platformcode)"
              type="TheCustom" size="small" style="float: right;margin: 10px 20px 0px 10px;">取消</el-button>
            <el-button v-if="noBjShow['index' + index + 'n' + n]"
              @click="differentSave(index, n, item2.name, item.id, item2.id)" type="primary" size="small"
              style="float: right;  margin-top: 10px;">保存</el-button>
            <el-button v-show="checked2['index' + index + 'n' + n] == true"
              :disabled="noDisabledSelect['index' + index + 'n' + n] == false" @click="newAdd(index, item.id, item.hid, n)"
              type="primary" size="small"
              style="float: right;margin-right: 20px;margin-top: 10px;">新增限价不同的产品</el-button>
          </span>
          <!-- 内部表格↓ -->
          <el-table v-show="checked2['index' + index + 'n' + n] == true" :data="tableData[index]"
            style="width: calc(100% - 20px);margin-top: 10px;" :show-header="false">
            <el-table-column prop="productname">
            </el-table-column>
            <el-table-column v-if="retrieve == 0 || retrieve == 2">
              <template slot-scope="scope">
                <div v-if="scope.row.filedname">
                  {{ scope.row.filedname }}
                </div>
                <div v-if="!scope.row.filedname">
                  {{ scope.row.pricename }}
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="retrieve == 1 || retrieve == 2">
              <template slot-scope="scope">
                <div v-if="scope.row.filednametheir">
                  {{ scope.row.filednametheir }}
                </div>
                <div v-else>
                  {{ scope.row.theirpricename }}
                </div>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-button :disabled="noDisabledSelect['index' + index + 'n' + n] == false"
                  @click="compile(index, scope.$index, item.id, item.hid, scope.row.productname, scope.row.productid, scope.row.pricename, scope.row.priceid, scope.row.filedname, scope.row.theirpricename, scope.row.theirpriceid)"
                  type="text" size="small">编辑</el-button>
                <el-button :disabled="noDisabledSelect['index' + index + 'n' + n] == false"
                  @click="expurgate(index, scope.$index)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 内部↑ -->
    </div>
    <!-- 平台限价不同 -->
    <!-- </div> -->


    <!-- 新增限价弹框 -->
    <div id="dialog">
      <el-dialog :title="newTitle" :visible.sync="theEditorShow" width="20%" style="margin-top: 10%;">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <el-form-item label="产品信息" :label-width="formLabelWidth" prop="productid">
            <el-select filterable size="small" clearable v-model="form.productid" @change="productAssignment"
              placeholder="全部">
              <el-option v-for="item in productData" :key="item.id" :value="item.id" :label="item.productClassifyName"
                :disabled="item.productLimit == true">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标价限价" :label-width="formLabelWidth" prop="priceid" v-if="retrieve == 0 || retrieve == 2">
            <el-select size="small" clearable v-model="form.priceid" @change="priceAssignment(form.priceid, 'a')"
              placeholder="请选择">
              <el-option v-for="item in addPriceData" :key="item.fieldvalue" :value="item.id" :label="item.fieldname"
                :disabled="item.priceLimit == true" v-if="item.isChecked == 1">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="到手价限价" :label-width="formLabelWidth" prop="theirpriceid"
            v-if="retrieve == 1 || retrieve == 2">
            <el-select size="small" clearable v-model="form.theirpriceid"
              @change="xinPriceAssignment(form.theirpriceid, 'a')" placeholder="请选择">
              <el-option v-for="item in addPriceData" :key="item.fieldvalue" :value="item.id" :label="item.fieldname"
                :disabled="item.priceLimit2 == true" v-if="item.isChecked == 1">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')" size="small">确 定</el-button>
          <el-button @click="theEditorShow = false" size="small" style="margin-left: 10px;" type="TheCustom">取
            消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 新增限价弹框 -->
     <!-- AI检索打标 -->
    <el-dialog title="提示" id="dialog" :visible.sync="aiShow" width="20%" style="margin-top: 10%;"
      :before-close="cancel" :close-on-click-modal="false">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">
            你确认<span style="color: red;">{{ reportKefuAuditing == '1' ? '开启' : '关闭' }}</span>AI打标吗？
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleCheckedCitiesChange" size="small">确 定</el-button>
        <el-button @click="searchEcho" size="small" type="TheCustom" style="margin-left: 10px;">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 品牌检索标准设置弹框 -->
    <el-dialog title="提示" id="dialog" :visible.sync="searchShow" width="20%" style="margin-top: 10%;"
      :before-close="cancel" :close-on-click-modal="false">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">
            你确认将品牌检索模式转换成<span style="color: red;">{{ priceSearch }}</span>检索吗？
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureSearch" size="small">确 定</el-button>
        <el-button @click="cancel" size="small" type="TheCustom" style="margin-left: 10px;">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 品牌检索标准设置弹框 -->
    <!-- 产品限价标准设置弹框 -->
    <el-dialog title="提示" id="dialog" :visible.sync="searchShow2" width="20%" style="margin-top: 10%;">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">
            你确认将产品限价标准切换成{{ priceSearch2 }}吗？
          </div>
          <div style="font-size: 16px;color: gray;">
            切换后<span style="color: red;">之前设置的限价标准将会被清空</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureSearch2" size="small">确 定</el-button>
        <el-button @click="searchShow2 = false" size="small" type="TheCustom" style="margin-left: 10px;">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 品产品限价标准设置弹框 -->
    <!-- 删除限价弹框 -->
    <el-dialog title="删除" id="dialog" :visible.sync="deleteShow" width="20%" style="margin-top: 10%;">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">你确认要删除该条限价产品吗？</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureDelete" size="small">确 定</el-button>
        <el-button @click="deleteShow = false" size="small" type="TheCustom" style="margin-left: 10px;">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 删除限价弹框 -->
    <!-- 删除tab页 -->
    <el-dialog title="删除" id="dialog" :visible.sync="deleteShowTab" width="20%" style="margin-top: 10%;">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">你确认要删除{{ sureTab }}吗？</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureDeletetab" size="small">确 定</el-button>
        <el-button @click="deleteShowTab = false" size="small" type="TheCustom" style="margin-left: 10px;">取
          消</el-button>
      </span>
    </el-dialog>
    <!-- 删除tab页 -->
  </div>
</template>
<script>
import pagination from "../../../components/dataTable/pagination";
import axios from "axios";
import preferentialSettings from "./preferentialSettings";
export default {
  data() {
    return {
      aiShow: false,
      reportKefuAuditing: '0',
      childRetrieve: '',
      WhetherEditor: '',
      filedname: '',
      filednametheir: '',
      newIndex: '',
      theTemplateId: '',
      eventIndex: '',
      priceToDelete: '',
      noDisabledSelect: [],
      disabledSelect: [],
      assignment: {},
      submitArray: {},
      sureDeletetabId: '',
      sureTab: '',
      deleteShowTab: false,
      differentPlatform: '',
      situationShow: '',
      plateList: [],
      disabledSameSave: [],
      iconShow: '',
      iconShow2: '',
      newTitle: '',
      editorId: '',
      indexValue: '',
      modeid: '',
      classifyidshow: '',
      hid: '',
      name: '',
      templateName: '',
      templateClassifyid: '',
      templateId: '',
      platformcode: '',
      priceidm: '',
      pricenamem: '',
      bjShow: [],
      noBjShow: [],
      // tab页↓
      tabIndex: 1,
      // tab页↑
      // 新增限价不同的产品↓
      classifyid: '',
      productData: [],
      productname: '',
      addPriceData: [],
      pricename: '',
      // 新增限价不同的产品↑
      retrieve: '0',// 品牌检索设置
      priceSearch: '',
      priceSearch2: '',
      ensure: '',
      limitedPriceNew: '',
      searchShow: false,// 品牌检索弹框
      searchShow2: false,// 产品限价标准弹框
      limitpricetype: '0',// 产品限价标准设置
      deleteShow: false, // 删除限价产品弹框
      theEditorShow: false, // 编辑限价产品弹框
      formLabelWidth: '100px',
      search: {},
      rules: {
        priceid: [
          { required: true, message: '请选择标价限价信息', trigger: 'blur' },
        ],
        theirpriceid: [
          { required: true, message: '请选择到手价限价信息', trigger: 'blur' },
        ],
        productid: [
          { required: true, message: '请选择产品信息', trigger: 'blur' },
        ],
      },// 编辑必填项
      form: {
        priceid: '',
        theirpriceid: '',
        productid: '',
      },// 编辑必填项
      priceData: [], //限价字段数据
      slimitPrices: [], //标价限价字段数据
      slimitPrices2: [], //标价限价字段数据

      theirPrices: [], //到手价限价字段数据
      theirPrices2: [], //到手价限价字段数据
      platform: [], //平台字段数据
      retList: [],
      entiretyShow: [],
      iShow: [],
      checked: [],
      checked2: {},
      totalNum: [],
      pageNo: 1,
      pageSize: 1000,
      tableData: []
    }
  },
  mounted() {
    this.searchEcho();
    if (this.$route.query.type && this.$route.query.type == 1) {
      this.$message({
        showClose: true,
        message: '请重新设置产品限价标准',
        type: 'warning'
      });
    }
  },
  methods: {
    aiChaneg() {
      this.aiShow = true
    },
    cancel() {
      this.ensure = this.retrieve = this.ensure
      this.searchShow = false
    },
    // 平台限价相同table
    retrieveListtable() {
      this.hid = this.modeid
      this.classifyid = this.classifyidshow
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        modeid: this.modeid,
        classifyid: this.classifyidshow,
      }
      fetch({
        url: "hcm/retrieve/retrieveSettingsList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.tableData[this.indexValue] = data.content
          this.totalNum = data.totalElements

          if (this.tableData[this.indexValue].length > 0) {
            this.checked[this.indexValue] = true
          } else {
            this.checked[this.indexValue] = false
          }
          this.tableData = { ...this.tableData }
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    // 相同标价限价赋值
    priceAssignment(id, index) {
      if (index === 'a') {
        let obj = {};
        obj = this.addPriceData.find((item) => {
          return item.id == id;//筛选出匹配数据
        });
        console.log(this.addPriceData)
        if (obj.fieldvalue) {
          this.pricename = obj.fieldvalue
          this.filedname = obj.fieldname
        }
      } else {
        let obj2 = {};
        obj2 = this.priceData[index].find((item) => {
          return item.id == id;//筛选出匹配数据
        });
        if (obj2.fieldvalue) {
          this.priceidm = id
          this.pricenamem = obj2.fieldvalue
          this.filedname = obj2.filedname
        }
      }
    },
    // 相同到手价限价赋值
    xinPriceAssignment(id, index) {
      if (index === 'a') {
        let obj = {};
        obj = this.addPriceData.find((item) => {
          return item.id == id;//筛选出匹配数据
        });
        console.log(this.addPriceData)
        if (obj.fieldvalue) {
          if (this.retrieve == 2) {
            this.theirpricename = obj.fieldvalue
            this.filednametheir = obj.fieldname
          } else {
            this.theirpricename = obj.fieldvalue
            this.filednametheir = obj.fieldname
          }
        }
      } else {
        let obj2 = {};
        obj2 = this.priceData[index].find((item) => {
          return item.id == id;//筛选出匹配数据
        });
        if (obj2.fieldvalue) {
          if (this.retrieve == 2) {
            this.theirpriceidm = id
            this.theirpricenamem = obj2.fieldvalue
            this.filednametheir = obj2.filedname
          } else {
            this.theirpriceidm = id
            this.theirpricenamem = obj2.fieldvalue
            this.filednametheir = obj2.filedname
          }

        }
      }
    },

    // 各平台现价相同保存

    sameSave(index, id, type, hid, pricenamem, priceidm) {

      let that = this
      if (this.retrieve == 0 || this.retrieve == 2) {
        if (!this.slimitPrices[index]) {
          this.$message({
            message: '请选择标价限价',
            type: 'warning'
          });
          return
        }
      } else if (this.retrieve == 1 || this.retrieve == 2) {
        if (!this.theirPrices[index]) {
          this.$message({
            message: '请选择到手价限价',
            type: 'warning'
          });
          return
        }
      }
      this.$set(this.disabledSameSave, index, false)
      console.log(this.retrieve)
      let params = {}
      if (this.retrieve == 0) {
        params.classifyidm = id
        params.pricenamem = this.pricenamem
        params.priceidm = this.priceidm
        params.name = '情况1'
      } else if (this.retrieve == 1) {
        params.classifyidm = id
        params.theirpricenamem = this.theirpricenamem
        params.theirpriceidm = this.theirpriceidm
        params.name = '情况1'
      } else if (this.retrieve == 2) {
        params.classifyidm = id
        params.theirpricenamem = this.theirpricenamem
        params.theirpriceidm = this.theirpriceidm
        params.pricenamem = this.pricenamem
        params.priceidm = this.priceidm
        params.name = '情况1'
      }
      if (hid) {
        params.id = hid
      }
      console.log(this.tableData[index])
      console.log(this.checked[index])
      // if (this.checked[index] == true) {
      let retrievesettingsList = []
      for (var i = 0; i < this.tableData[index].length; i++) {
        if (this.tableData[index][i]) {
          // 0是变价  1是到手价  2是标价加上到手价
          if (this.retrieve == 0) {
            retrievesettingsList.push({
              classifyid: id,
              priceid: this.tableData[index][i].priceid,
              pricename: this.tableData[index][i].pricename,
              productid: this.tableData[index][i].productid,
              productname: this.tableData[index][i].productname,
            })
          } else if (this.retrieve == 1) {
            console.log('到手价检索')
            console.log(this.tableData[index][i])

            retrievesettingsList.push({
              classifyid: id,
              theirpriceid: this.tableData[index][i].theirpriceid,
              theirpricename: this.tableData[index][i].theirpricename,
              productid: this.tableData[index][i].productid,
              productname: this.tableData[index][i].productname,
            })
          } else if (this.retrieve == 2) {
            retrievesettingsList.push({
              classifyid: id,
              priceid: this.tableData[index][i].priceid,
              pricename: this.tableData[index][i].pricename,
              theirpriceid: this.tableData[index][i].theirpriceid,
              theirpricename: this.tableData[index][i].theirpricename,
              productid: this.tableData[index][i].productid,
              productname: this.tableData[index][i].productname,
            })
          }
        }
      }
      if (retrievesettingsList.length > 0 && this.checked[index] == true) {
        params.retrievesettingsList = retrievesettingsList
      } else {
        params.type = 0
      }
      // }
      axios({
        method: 'post',
        url: 'hcm/retrieve/saveRetrieveSettings',
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        },
        data: params,
        timeout: 60 * 1000 * 50
      }).then(function (response) {
        if (response.data.status == "10000") {
          that.$message({
            message: '保存成功',
            type: 'success'
          });
          that.$set(that.disabledSameSave, index, true)
          that.toBeSet()
        } else {
          that.$message.error(response.data.message)
        }
      })
    },
    // 编辑
    bjButton(index, f, hid) {
      this.indexValue = index
      this.modeid = hid
      this.classifyidshow = f
      this.$set(this.disabledSelect, index, true);
      this.$set(this.iShow, index, false);
      this.$set(this.entiretyShow, index, true);
      this.$set(this.bjShow, index, false);
      this.$set(this.noBjShow, index, true);
      this.getByProduct(index, f)
      this.toBeSet2()
      this.retrieveListtable()
      console.log(this.priceData)
    },
    // 取消编辑
    noBjButton(index, f, hid) {
      this.indexValue = index
      this.modeid = hid
      this.classifyidshow = f
      this.$set(this.disabledSelect, index, false);
      this.$set(this.iShow, index, true);
      this.$set(this.entiretyShow, index, false);
      this.$set(this.bjShow, index, true);
      this.$set(this.noBjShow, index, false);
      this.toBeSet2()
      this.getByProduct(index, f)
      this.retrieveListtable()
    },
    cancelPlatform(event) {
      for (var i = 0; i < this.plateList[this.eventIndex].length; i++) {
        if (event === this.plateList[this.eventIndex][i].dictCode) {
          this.plateList[this.eventIndex][i].suredes = false
        }
      }
    },
    // 限价不同平台筛选
    platformScreen(e, index, n) {
      this.eventIndex = index
      this.differentPlatform = []
      if (e) {
        this.differentPlatform = e.join();
      }
      for (var i = 0; i < this.plateList[index].length; i++) {
        for (var a = 0; a < e.length; a++) {
          if (e[a] === this.plateList[index][i].dictCode) {
            this.plateList[index][i].suredes = true
          }
        }
      }
      this.plateList = { ...this.plateList }
    },
    // 限价不同获取平台
    GetList(index, n, platformcode) {
      console.log(platformcode)
      let params = {
        dictcode: 'platform',
        pricename: 'main',
      }
      fetch({
        url: "hcm/sys/GetList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          console.log('平台过滤判断条件')
          console.log(this.plateList[index])
          if (!this.plateList[index]) {
            let arr = []
            let newArr = []
            arr = data
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].pricename == "main" && arr[i].dictName != '其他') {
                arr[i].suredes = false
                newArr.push(arr[i])
              }
            }
            if (platformcode) {
              let arrCode = []
              arrCode = platformcode.split(",");
              console.log(arrCode)
              for (var q = 0; q < newArr.length; q++) {
                for (var z = 0; z < arrCode.length; z++) {
                  if (arrCode[z] === newArr[q].dictCode) {
                    newArr[q].suredes = true
                  }
                }
              }
            }
            this.plateList[index] = newArr
          }
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    // 不同编辑
    bjButton2(index, n) {
      this.indexValue = index
      let str = ''
      let newstrArr = []
      this.bjShow['index' + index + 'n' + n] = false
      this.noBjShow['index' + index + 'n' + n] = true
      this.noDisabledSelect['index' + index + 'n' + n] = true
      this.noBjShow = { ...this.noBjShow }
      this.bjShow = { ...this.bjShow }
      this.noDisabledSelect = { ...this.noDisabledSelect }
      //  不同编辑时筛选平台
      for (var a = 0; a < this.retList[index].getRetrievemode.length; a++) {
        if (this.retList[index].getRetrievemode[a].platformcode) {
          str += this.retList[index].getRetrievemode[a].platformcode + ','
        }
      }
      str = str.substr(0, str.length - 1);
      newstrArr = str.split(",")
      if (this.plateList[index]) {
        for (var a = 0; a < this.plateList[index].length; a++) {
          for (var z = 0; z < newstrArr.length; z++) {
            if (newstrArr[z] === this.plateList[index][a].dictCode) {
              this.plateList[index][a].suredes = true
            }
          }
        }
      }
    },
    // 不同取消编辑
    noBjButton2(index, n, product_classify_name, e, f, id2, name, platformcode) {
      this.bjShow['index' + index + 'n' + n] = true
      this.noBjShow['index' + index + 'n' + n] = false
      this.noDisabledSelect['index' + index + 'n' + n] = false
      this.noBjShow = { ...this.noBjShow }
      this.bjShow = { ...this.bjShow }
      this.toBeSet2()
      this.getByProduct(index, f, n)
      this.GetList(index, n, platformcode)
      this.dataUpdate(id2, f, index)
    },
    // 鼠标悬浮
    stopHover(product_classify_name, n) {
      this.iconShow = product_classify_name + n
    },
    // 鼠标离开
    leave() {
      this.iconShow = ''
    },
    // 不同保存
    differentSave(index, n, name, f, theTemplateId, platformcode, priceidm, pricenamem) {
      let obj = {};
      let obj2 = {};
      let pricenamem2;
      let pricenamem3;
      let that = this
      if (this.platform['index' + index + 'n' + n].length == 0) {
        this.$message({
          message: name + '请选择平台',
          type: 'warning'
        });
        return
      }

      if (this.retrieve == 0 || this.retrieve == 2) {
        if (!this.slimitPrices2['index' + index + 'n' + n]) {
          this.$message({
            message: name + '请选择标价限价',
            type: 'warning'
          });
          return
        }
      }

      if (this.retrieve == 1 || this.retrieve == 2) {
        if (!this.theirPrices2['index' + index + 'n' + n]) {
          this.$message({
            message: name + '请选择到手价限价',
            type: 'warning'
          });
          return
        }
      }
      if (this.retrieve == 0) {
        obj = this.priceData['index' + index + 'n' + n].find((item) => {
          return item.id == this.slimitPrices2['index' + index + 'n' + n];//筛选出匹配数据
        });

        if (obj.fieldvalue) {
          pricenamem2 = obj.fieldvalue
        }
      } else if (this.retrieve == 1) {
        obj2 = this.priceData['index' + index + 'n' + n].find((item) => {
          return item.id == this.theirPrices2['index' + index + 'n' + n];//筛选出匹配数据
        });
        if (obj2.fieldvalue) {
          pricenamem3 = obj2.fieldvalue
        }
      } else if (this.retrieve == 2) {
        obj = this.priceData['index' + index + 'n' + n].find((item) => {
          return item.id == this.slimitPrices2['index' + index + 'n' + n];//筛选出匹配数据
        });

        obj2 = this.priceData['index' + index + 'n' + n].find((item) => {
          return item.id == this.theirPrices2['index' + index + 'n' + n];//筛选出匹配数据
        });

        if (obj.fieldvalue) {
          pricenamem2 = obj.fieldvalue
        }

        if (obj2.fieldvalue) {
          pricenamem3 = obj2.fieldvalue
        }
      }

      // this.noDisabledDifferentSave['index'+index + 'n' + n] = false
      if (!theTemplateId) {
        theTemplateId = this.theTemplateId
      }
      console.log(this.tableData[index])
      let arr = []
      arr = this.tableData[index]
      this.tableData[index] = []
      for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
          this.tableData[index].push(arr[i])
        }
      }
      this.submitArray = []
      if (this.retrieve == 0) {
        for (var i = 0; i < this.tableData[index].length; i++) {
          this.submitArray.push({
            classifyid: f,
            priceid: this.tableData[index][i].priceid,
            pricename: this.tableData[index][i].pricename,
            productid: this.tableData[index][i].productid,
            productname: this.tableData[index][i].productname,
          })
        }
      } else if (this.retrieve == 1) {
        for (var i = 0; i < this.tableData[index].length; i++) {
          this.submitArray.push({
            classifyid: f,
            theirpriceid: this.tableData[index][i].theirpriceid,
            theirpricename: this.tableData[index][i].theirpricename,
            productid: this.tableData[index][i].productid,
            productname: this.tableData[index][i].productname,
          })
        }
      } else if (this.retrieve == 2) {
        for (var i = 0; i < this.tableData[index].length; i++) {
          this.submitArray.push({
            classifyid: f,
            priceid: this.tableData[index][i].priceid,
            pricename: this.tableData[index][i].pricename,
            theirpriceid: this.tableData[index][i].theirpriceid,
            theirpricename: this.tableData[index][i].theirpricename,
            productid: this.tableData[index][i].productid,
            productname: this.tableData[index][i].productname,
          })
        }
      }
      let params = {
        classifyidm: f,
        id: theTemplateId,
        name: name,
        platformcode: this.platform['index' + index + 'n' + n].join(),
      }
      if (this.retrieve == 0) {
        params.priceidm = this.slimitPrices2['index' + index + 'n' + n]
        params.pricenamem = pricenamem2
      } else if (this.retrieve == 1) {
        params.theirpriceidm = this.theirPrices2['index' + index + 'n' + n]
        params.theirpricenamem = pricenamem3
      } else if (this.retrieve == 2) {
        params.priceidm = this.slimitPrices2['index' + index + 'n' + n]
        params.pricenamem = pricenamem2
        params.theirpriceidm = this.theirPrices2['index' + index + 'n' + n]
        params.theirpricenamem = pricenamem3
      }

      if (this.submitArray.length > 0 && this.checked2['index' + index + 'n' + n] == true) {
        params.retrievesettingsList = this.submitArray
      } else {
        params.type = 0
      }
      axios({
        method: 'post',
        url: 'hcm/retrieve/saveRetrieveSettings',
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        },
        data: params
      }).then(function (response) {
        if (response.data.status == "10000") {
          that.$message({
            message: '保存成功',
            type: 'success'
          });
          that.toBeSet(index)
        } else {
          that.$message.error(response.data.message)
        }
      })
    },
    // 产品信息赋值
    productAssignment(vId) {//这个vId也就是value值
      let obj = {};
      obj = this.productData.find((item) => {
        return item.id == vId;//筛选出匹配数据
      });
      if (obj.productClassifyName) {
        this.productname = obj.productClassifyName
      }
    },
    // 平台限价不同限价赋值
    priceAssignment2(id, index, n) {
      this.priceToDelete = id
      if (index === 'a') {
        let obj = {};
        obj = this.addPriceData.find((item) => {
          return item.id == id;//筛选出匹配数据
        });
        if (obj.fieldvalue) {
          this.pricename = obj.fieldvalue
        }
      } else {
        let obj2 = {};
        obj2 = this.priceData['index' + index + 'n' + n].find((item) => {
          return item.id == id;//筛选出匹配数据
        });
        if (obj2.fieldvalue) {
          this.priceidm = id
          this.pricenamem = obj2.fieldvalue
        }
      }
      this.priceData = { ...this.priceData }
    },
    // 不同到手价限价赋值
    xinPriceAssignment2(id, index, n) {
      this.priceToDelete = id
      if (index === 'a') {
        let obj = {};
        obj = this.addPriceData.find((item) => {
          return item.id == id;//筛选出匹配数据
        });
        if (obj.fieldvalue) {
          this.theirpricename = obj.fieldvalue
        }
      } else {
        let obj2 = {};
        obj2 = this.priceData['index' + index + 'n' + n].find((item) => {
          return item.id == id;//筛选出匹配数据
        });
        if (obj2.fieldvalue) {
          this.theirpriceidm = id
          this.theirpricenamem = obj2.fieldvalue
        }
      }
      this.priceData = { ...this.priceData }
    },

    // 不同情况下允许部分产品限价不同
    noCheckedHits(index, n) {
      let platformcode
      platformcode = this.platform['index' + index + 'n' + n].join();
      if (this.checked2['index' + index + 'n' + n] == true) {
        this.$set(this.checked2, this.checked2['index' + index + 'n' + n], false)
      } else {
        this.$set(this.checked2, this.checked2['index' + index + 'n' + n], true)
      }
      this.checked2 = { ...this.checked2 }
    },
    // 产品限价标准设置回显
    toBeSet(e) {
      console.log('进来')
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      fetch({
        url: "hcm/retrieve/retrieveList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.retList = []
          this.bjShow = []
          this.noDisabledSelect = []
          this.checked2 = {}
          this.platform = []
          this.slimitPrices2 = []
          this.theirPrices2 = []
          this.noBjShow = []
          this.retList = data.content
          if (e == 1) {
            this.retList = data.content
          }
          console.log('this.limitpricetype' + this.limitpricetype)
          if (this.limitpricetype == '0') {
            console.log('执行几次')
            this.getByProduct(0, data.content[0].id)
          }
          for (var i = 0; i < data.content.length; i++) {
            //各平台限价不同  允许部分商品限价不同回显
            if (this.limitpricetype == '1') {
              console.log('this.limitpricetype' + this.limitpricetype)
              if (data.content[i].getRetrievemode) {
                for (var a = 0; a < data.content[i].getRetrievemode.length; a++) {
                  if (data.content[i].getRetrievemode[a].retrievesettingsList) {
                    for (var b = 0; b < data.content[i].getRetrievemode[a].retrievesettingsList.length; b++) {
                      if (data.content[i].getRetrievemode[a].retrievesettingsList) {
                        this.tableData[i] = data.content[i].getRetrievemode[a].retrievesettingsList
                      }
                    }
                  } else {
                    this.tableData[i] = []
                  }
                  if (data.content[i].getRetrievemode[a].retrievesettingsList) {
                    this.checked2['index' + i + 'n' + a] = true
                  } else {
                    this.checked2['index' + i + 'n' + a] = false
                  }
                  //各平台限价不同  平台回显
                  if (data.content[i].getRetrievemode[a].platformcode) {
                    this.platform['index' + i + 'n' + a] = data.content[i].getRetrievemode[a].platformcode.split(",");
                  }
                  console.log(this.platform)
                  //各平台限价不同  限价回显
                  if (data.content[i].getRetrievemode[a].priceidm) {
                    this.slimitPrices2['index' + i + 'n' + a] = data.content[i].getRetrievemode[a].priceidm
                    console.log(data.content[i].getRetrievemode[a].priceidm)
                  }
                  if (data.content[i].getRetrievemode[a].theirpriceidm) {
                    console.log(data.content[i].getRetrievemode[a].theirpriceidm)
                    this.theirPrices2['index' + i + 'n' + a] = data.content[i].getRetrievemode[a].theirpriceidm
                  }
                  this.bjShow['index' + i + 'n' + a] = true
                  this.noBjShow['index' + i + 'n' + a] = false
                  this.noDisabledSelect['index' + i + 'n' + a] = false
                }
              } else {
                data.content[i].getRetrievemode = []
                data.content[i].getRetrievemode.push({
                  name: '情况' + 1,
                });
                for (var a = 0; a < data.content[i].getRetrievemode.length; a++) {
                  if (data.content[i].getRetrievemode[a].retrievetype && data.content[i].getRetrievemode[a].retrievetype == '1') {
                    this.checked2['index' + i + 'n' + a] = true
                  } else {
                    this.checked2['index' + i + 'n' + a] = false
                  }
                  //各平台限价不同  平台回显
                  if (data.content[i].getRetrievemode[a].platformcode) {
                    this.platform['index' + i + 'n' + a] = data.content[i].getRetrievemode[a].platformcode.split(",");
                  }
                  //各平台限价不同  限价回显
                  if (data.content[i].getRetrievemode[a].priceidm) {
                    this.slimitPrices2['index' + i + 'n' + a] = data.content[i].getRetrievemode[a].priceidm
                    console.log(data.content[i].getRetrievemode[a].priceidm)
                  }
                  if (data.content[i].getRetrievemode[a].theirpriceidm) {
                    this.theirPrices2['index' + i + 'n' + a] = data.content[i].getRetrievemode[a].theirpriceidm
                  }
                  this.bjShow['index' + i + 'n' + a] = true
                  this.noBjShow['index' + i + 'n' + a] = false
                  this.noDisabledSelect['index' + i + 'n' + a] = false
                }
              }
            } else {
              // 相同处理
              this.slimitPrices[i] = data.content[i].priceidm
              this.theirPrices[i] = data.content[i].theirpriceidm
              if (data.content[i].retrievetype == 1) {
                this.$set(this.checked, i, true);
                this.slimitPrices[i] = data.content[i].priceidm
                this.theirPrices[i] = data.content[i].theirpriceidm
              } else {
                this.$set(this.checked, i, false);
              }
              this.$set(this.bjShow, i, true);
              this.$set(this.noBjShow, i, false);
              this.$set(this.disabledSelect, i, false);
            }
            // 相同/不同公共方法
            this.$set(this.iShow, i, true);
            this.$set(this.entiretyShow, i, false);
          }
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    toBeSet2() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      fetch({
        url: "hcm/retrieve/retrieveList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          if (this.eventIndex) {
            for (var i = 0; i < this.plateList[this.eventIndex].length; i++) {
              if (this.plateList[this.eventIndex][i]) {
                this.plateList[this.eventIndex][i].suredes = false
              }
            }
          }
          this.retList = []
          this.platform = []
          this.slimitPrices2 = []
          this.theirPrices2 = []

          this.retList = data.content
          for (var i = 0; i < this.retList.length; i++) {
            if (this.limitpricetype == '0') {
              this.slimitPrices[i] = this.retList[i].priceidm
              this.theirPrices[i] = this.retList[i].theirpriceidm
            } else {
              if (this.limitpricetype == '1') {
                if (this.retList[i].getRetrievemode) {
                  for (var a = 0; a < this.retList[i].getRetrievemode.length; a++) {
                    //各平台限价不同  平台回显
                    if (this.retList[i].getRetrievemode[a].platformcode) {
                      this.platform['index' + i + 'n' + a] = this.retList[i].getRetrievemode[a].platformcode.split(",");
                    }
                    //各平台限价不同  限价回显
                    if (this.retList[i].getRetrievemode[a].priceidm) {
                      this.slimitPrices2['index' + i + 'n' + a] = this.retList[i].getRetrievemode[a].priceidm
                      console.log(this.retList[i].getRetrievemode[a].priceidm)
                    }
                    if (this.retList[i].getRetrievemode[a].theirpriceidm) {
                      this.theirPrices2['index' + i + 'n' + a] = this.retList[i].getRetrievemode[a].theirpriceidm
                    }


                  }
                  this.platform = { ...this.platform }
                  this.slimitPrices2 = { ...this.slimitPrices2 }
                  this.theirPrices2 = { ...this.theirPrices2 }
                } else {
                  this.retList[i].getRetrievemode = []
                  this.retList[i].getRetrievemode.push({
                    name: '情况' + 1,
                  });
                  for (var a = 0; a < this.retList[i].getRetrievemode.length; a++) {
                    //各平台限价不同  平台回显
                    if (this.retList[i].getRetrievemode[a].platformcode) {
                      this.platform['index' + i + 'n' + a] = this.retList[i].getRetrievemode[a].platformcode.split(",");
                    }
                    //各平台限价不同  限价回显
                    if (this.retList[i].getRetrievemode[a].priceidm) {
                      this.slimitPrices2['index' + i + 'n' + a] = this.retList[i].getRetrievemode[a].priceidm
                      console.log(this.retList[i].getRetrievemode[a].priceidm)
                    }
                    if (this.retList[i].getRetrievemode[a].theirpriceidm) {
                      this.theirPrices2['index' + i + 'n' + a] = this.retList[i].getRetrievemode[a].theirpriceidm
                    }
                  }
                  this.platform = { ...this.platform }
                  this.slimitPrices2 = { ...this.slimitPrices2 }
                  this.theirPrices2 = { ...this.theirPrices2 }
                }
              }
            }
          }
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    // 限价
    getByProduct(index, f, n) {

      console.log('编辑')
      console.log(index)
      console.log(f)
      let params = {
        productClassifyid: f
      }
      fetch({
        url: "hcm/hcmCustomModel/getByProduct",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          console.log(data.price.data)
          if (data.price.data) {
            if (n || n == 0) {
              this.priceData['index' + index + 'n' + n] = data.price.data
            } else {
              console.log(data.price.data)
              console.log(index)
              this.priceData[index] = data.price.data
              for (var a = 0; a < this.priceData[index].length; a++) {
                this.priceData[index][a].priceLimit = false
                this.priceData[index][a].priceLimit2 = false
              }
              console.log(this.priceData[index])
              if (this.limitpricetype == '0') {
                console.log(this.priceData)
                console.log(this.priceData[index])
                if (this.priceData[index]) {
                  for (var i = 0; i < this.priceData[index].length; i++) {
                    if (this.slimitPrices[index] == this.priceData[index].id) {
                      this.priceData[index][i].priceLimit = true
                    }
                    if (this.theirPrices[index] == this.priceData[index].id) {
                      this.priceData[index][i].priceLimit2 = true
                    }
                  }
                }

                if (this.slimitPrices[index]) {
                  let obj = {};
                  obj = this.priceData[index].find((item) => {
                    return item.id == this.slimitPrices[index];//筛选出匹配数据
                  });
                  if (obj.fieldvalue) {
                    this.priceidm = this.slimitPrices[index]
                    this.pricenamem = obj.fieldvalue
                    this.filedname = obj.fieldname
                  }
                }
                if (this.theirPrices[index]) {
                  let obj2 = {};
                  obj2 = this.priceData[index].find((item) => {
                    return item.id == this.theirPrices[index];//筛选出匹配数据
                  });
                  if (obj2.fieldvalue) {
                    this.theirpriceidm = this.theirPrices[index]
                    this.theirpricenamem = obj2.fieldvalue
                    this.filednametheir = obj2.fieldname
                  }
                }
              }
            }
          }
          this.priceData = { ...this.priceData }
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    // 编辑限价产品确认
    submitForm(formName) {
      console.log(this.form.theirpriceid)
      console.log(this.newIndex)
      console.log(this.WhetherEditor)
      console.log(this.tableData)
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.tableData[this.newIndex]) {
            this.tableData[this.newIndex] = []
          }
          if (this.WhetherEditor != '' || this.WhetherEditor === 0) {
            let arr = []
            arr = this.tableData[this.newIndex]
            this.tableData[this.newIndex] = []
            for (var i = 0; i < arr.length; i++) {
              if (arr[i]) {
                this.tableData[this.newIndex].push(arr[i])
              }
            }
            if (!this.tableData[this.newIndex][this.WhetherEditor]) {

            } else {
              console.log(this.fieldname)
              this.tableData[this.newIndex][this.WhetherEditor].pricename = this.pricename
              this.tableData[this.newIndex][this.WhetherEditor].priceid = this.form.priceid
              this.tableData[this.newIndex][this.WhetherEditor].theirpricename = this.theirpricename
              this.tableData[this.newIndex][this.WhetherEditor].theirpriceid = this.form.theirpriceid
              this.tableData[this.newIndex][this.WhetherEditor].productname = this.productname
              this.tableData[this.newIndex][this.WhetherEditor].productid = this.form.productid
              this.tableData[this.newIndex][this.WhetherEditor].filedname = this.filedname
              this.tableData[this.newIndex][this.WhetherEditor].filednametheir = this.filednametheir
            }
            console.log(this.fieldname)
            console.log('赋值')
            console.log(this.tableData[this.newIndex][this.WhetherEditor])
            this.WhetherEditor = ''
          } else {
            this.tableData[this.newIndex].push({
              pricename: this.pricename,
              priceid: this.form.priceid,
              theirpricename: this.theirpricename,
              theirpriceid: this.form.theirpriceid,
              productname: this.productname,
              productid: this.form.productid,
              filedname: this.filedname,
              filednametheir: this.filednametheir,
            })
          }
          console.log('赋值2')
          console.log(this.fieldname)
          console.log(this.tableData[this.newIndex])
          that.theEditorShow = false
          this.productname = ''
          this.form.productid = ''
          this.pricename = ''
          this.form.priceid = ''
          this.theirpricename = ''
          this.form.theirpriceid = ''
          this.filedname = ''
          this.filednametheir = ''
        }
      });
    },
    // 新增
    newAdd(index, classifyid, hid) {
      this.newTitle = '新增'
      this.theEditorShow = true
      this.newIndex = index
      this.productInformation(index, classifyid)
    },
    // 产品信息赋值
    productInformation(index, classifyid) {
      let params = {
        classifyid: classifyid,
        type: 1
      }
      fetch({
        url: "hcm/hcmProduct/getRetrievesList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.productData = data
          // if (this.limitpricetype == 0 && this.tableData[this.newIndex]) {
          if (this.tableData[this.newIndex]) {
            for (var i = 0; i < this.productData.length; i++) {
              for (var a = 0; a < this.tableData[this.newIndex].length; a++) {
                if (this.tableData[this.newIndex][a] && this.tableData[this.newIndex][a].productname == this.productData[i].productClassifyName) {
                  this.productData[i].productLimit = true
                }
              }
            }
          }
          this.newIndex = index
          this.addPrice(index, classifyid)
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    // 新增限价赋值
    addPrice(index, classifyid) {
      let params = {
        productClassifyid: classifyid
      }
      fetch({
        url: "hcm/hcmCustomModel/getByProduct",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          if (data.price.data) {
            this.addPriceData = []
            this.addPriceData = data.price.data
            console.log(this.addPriceData)
            // 把priceToDelete置空用来判断是否要删除限价数组中的一项
            if (this.limitpricetype == '1' && this.priceToDelete != '') {
              for (var a = 0; a < this.addPriceData.length; a++) {
                if (this.addPriceData[a].id === this.priceToDelete) {
                  this.addPriceData[a].priceLimit = true
                  this.addPriceData[a].priceLimit2 = true
                } else {
                  this.addPriceData[a].priceLimit = false
                  this.addPriceData[a].priceLimit2 = false
                }
              }
            }
            if (this.limitpricetype == '0') {
              for (var a = 0; a < this.addPriceData.length; a++) {
                // 标价
                if (this.addPriceData[a].id === this.slimitPrices[index]) {
                  this.addPriceData[a].priceLimit = true
                } else {
                  this.addPriceData[a].priceLimit = false
                }
                // 到手价
                if (this.addPriceData[a].id === this.theirPrices[index]) {
                  this.addPriceData[a].priceLimit2 = true
                } else {
                  this.addPriceData[a].priceLimit2 = false
                }
              }
            }
          }
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    handleCheckedCitiesChange() {
			let params = {
				reportKefuAuditing: Number(this.reportKefuAuditing),
			}
			fetch({
				url: "/hcm/cus/updateReportKefuAuditing",
				method: "post",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let { data } = res
				if (res.status == '10000') {
					this.searchEcho()
				} else {
					this.$message({
						message: res.message,
						type: "error"
					});
				}
			})
		},
    // 标准设置回显
    searchEcho() {
      fetch({
        url: "hcm/cus/selectbmcSetting",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.aiShow = false
          this.reportKefuAuditing = data.productAi.toString()
          if (data.retrieve) {
            this.retrieve = data.retrieve
            this.childRetrieve = data.retrieve
          } else {
            this.retrieve = '0'
          }
          console.log('data.limitpricetype' + data.limitpricetype)
          if (data.limitpricetype) {
            this.limitpricetype = data.limitpricetype
          } else {
            this.limitpricetype = '0'
          }
          this.ensure = this.retrieve
          this.toBeSet();
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    // 品牌检索模式转换确认按钮
    sureSearch() {
      let params = {
        retrieve: this.retrieve
      }
      fetch({
        url: "hcm/cus/updateretrieve",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.searchEcho()
          this.searchShow = false
          this.toBeSet()
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    // 品牌检索模式转换
    priceSerch(e, f) {
      if (e == '到手价检索') {
        this.priceSearch = '到手价'
      } else if (e == '标价检索') {
        this.priceSearch = '标价'
      } else {
        this.priceSearch = '标价&到手价检索'
      }
      this.searchShow = true
    },
    // 产品限价标准模式转换确认按钮
    sureSearch2() {
      this.limitpricetype = this.limitedPriceNew
      let params = {
        limitpricetype: this.limitpricetype
      }
      fetch({
        url: "hcm/cus/updateretrieve",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.searchEcho()
          this.toBeSet();
          this.searchShow2 = false
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    // 产品限价模式转换
    productPrice(e, f) {
      this.plateList = []
      this.tableData = []
      this.limitedPriceNew = f
      if (e == '各平台限价不同') {
        this.priceSearch2 = '各平台限价不同'
        this.limitpricetype = '0'
      } else {
        this.priceSearch2 = '各平台限价相同'
        this.limitpricetype = '1'
      }
      this.searchShow2 = true
    },
    // 编辑
    compile(index, n, classifyid, id, productname, productid, pricename, priceid, filedname, theirpricename, theirpriceid) {
      console.log(filedname)
      console.log(productname)
      this.newTitle = '编辑'
      this.theEditorShow = true
      this.editorId = id
      // if (this.limitpricetype == 0) {
      this.WhetherEditor = n
      this.productname = productname
      this.form.productid = productid
      this.pricename = pricename
      this.form.priceid = priceid
      this.theirpricename = theirpricename
      this.form.theirpriceid = theirpriceid
      this.filedname = filedname
      // }
      console.log(this.productname)
      this.productInformation(index, classifyid)

    },
    // 删除限价弹框
    expurgate(index, n) {
      console.log('删除')
      this.deleteShow = true
      // if (this.limitpricetype == 0) {
      //   this.WhetherEditor = n
      //   this.newIndex = index
      // }
      this.WhetherEditor = n
      this.newIndex = index
    },

    // 确认删除限价
    sureDelete() {
      // if (this.limitpricetype == 0) {
      let arr = []
      if (this.tableData[this.newIndex]) {
        arr = this.tableData[this.newIndex]
        this.tableData[this.newIndex] = []
        for (var i = 0; i < arr.length; i++) {
          if (arr[i]) {
            this.tableData[this.newIndex].push(arr[i])
          }
        }
      }
      delete this.tableData[this.newIndex][this.WhetherEditor]
      this.deleteShow = false
      this.WhetherEditor = ''
      this.tableData = { ...this.tableData }
      // }
    },
    // 展开产品
    showBtn(index, f, hid) {
      console.log('相同展开')
      this.indexValue = index
      this.modeid = hid
      this.classifyidshow = f
      this.getByProduct(index, f)
      this.retrieveListtable()
      if (this.iShow[index] == true) {
        this.$set(this.iShow, index, false);
        this.$set(this.entiretyShow, index, true);
      } else {
        this.$set(this.iShow, index, true);
        this.$set(this.entiretyShow, index, false);
      }
    },
    showBtn2(index, f, hid) {
      this.indexValue = index
      this.modeid = hid
      this.classifyidshow = f
      if (this.iShow[index] == true) {
        this.$set(this.iShow, index, false);
        this.$set(this.entiretyShow, index, true);
      } else {
        this.$set(this.iShow, index, true);
        this.$set(this.entiretyShow, index, false);
      }
    },

    // 各平台限价不同↓
    // 添加情况
    addTab(getRetrievemode, index) {
      this.priceToDelete = ''
      let numArr = []
      let hxNumArr = []
      let newMaxArr = []
      let newArr2 = []
      let noUndefined
      if (getRetrievemode) {
        if (getRetrievemode.length == 8) {
          this.$message({
            message: '最多存在8条',
            type: 'warning'
          });
          return;
        } else {
          if (getRetrievemode[0].name !== '情况1') {
            // if (getRetrievemode.length > 1) {
            //  先转成数字
            for (var a = 0; a < getRetrievemode.length; a++) {
              numArr.push(getRetrievemode[a].name.substring(2, 3))
              this.noDisabledSelect['index' + i + 'n' + a] = false
            }
            // 然后取最大值
            var max;
            for (var i = 0; i < numArr.length; i++) {
              for (var j = i; j < numArr.length; j++) {
                if (numArr[i] < numArr[j]) {
                  max = numArr[j];
                  numArr[j] = numArr[i];
                  numArr[i] = max;
                }
              }
            }
            // 根据最大值数组添加数据
            for (var h = 1; h < numArr[0]; h++) {
              newMaxArr.push(h)
            }
            // 筛选重复数据
            var temp01 = [];
            var temp02 = [];
            for (var i in numArr) {
              temp01[numArr[i]] = true;
            }
            for (var k in newMaxArr) {
              if (!temp01[newMaxArr[k]]) {
                temp02.push(newMaxArr[k])
              }
            }
            noUndefined = temp02[0]
            if (noUndefined == undefined) {
              this.tabIndex = parseInt(getRetrievemode.length) + 1
              getRetrievemode.push({
                name: '情况' + this.tabIndex,
              });
            } else {
              getRetrievemode.push({
                name: '情况' + noUndefined,
              });
            }
          } else {
            console.log('直接添加')
            this.tabIndex = parseInt(getRetrievemode.length) + 1
            getRetrievemode.push({
              name: '情况' + this.tabIndex,
            });
          }
          for (var a = 0; a < getRetrievemode.length; a++) {
            this.bjShow['index' + index + 'n' + a] = true
            this.noBjShow['index' + index + 'n' + a] = false
          }
          this.bjShow = { ...this.bjShow }
          this.noBjShow = { ...this.noBjShow }
        }
      } else {
        getRetrievemode.push({
          name: '情况' + 1,
        });
      }
      for (var a = 0; a < getRetrievemode.length; a++) {
        this.noDisabledSelect['index' + index + 'n' + a] = false
      }
    },
    // 删除tab
    removeTab(getRetrievemode, index, n, name, platformcode, platform) {
      console.log(platformcode)
      console.log(platform)
      var platformcode2
      if (getRetrievemode.length == 1) {
        this.$message({
          message: '必须存在一条',
          type: 'warning'
        });
        return;
      } else {
        // this.assignment[index] = 'false'
        if (getRetrievemode[n].id) {
          this.sureDeletetabId = getRetrievemode[n].id
          this.sureTab = name
          this.deleteShowTab = true
        } else {
          delete this.checked2['index' + index + 'n' + n]
          // delete tableData[index]
          delete this.platform['index' + index + 'n' + n]
          delete this.slimitPrices2['index' + index + 'n' + n]
          delete this.theirPrices2['index' + index + 'n' + n]
          getRetrievemode.splice(n, 1);
        }
      }
      if (platform) {
        platformcode = platform.join()
      }
      platformcode = platformcode.split(",")
      console.log(platformcode)
      for (var a = 0; a < this.plateList[index].length; a++) {
        for (var z = 0; z < platformcode.length; z++) {
          if (platformcode[z] === this.plateList[index][a].dictCode) {
            this.plateList[index][a].suredes = false
          }
        }
      }
      console.log(this.plateList[index])
    },
    // 确认删除tab页面
    sureDeletetab() {
      let params = {
        id: this.sureDeletetabId
      }
      fetch({
        url: "hcm/retrieve/deleteRetrieveSettingsmode",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.toBeSet()
          this.deleteShowTab = false
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    // 触发Tab
    clickTab(product_classify_name, n, e, index, f, id2, name, platformcode) {
      if (this.slimitPrices2['index' + index + 'n' + n]) {
        this.priceToDelete = this.slimitPrices2['index' + index + 'n' + n]
        console.log(this.slimitPrices2['index' + index + 'n' + n])
      } else {
        this.priceToDelete = ''
      }
      if (this.theirPrices2['index' + index + 'n' + n]) {
        this.priceToDelete = this.theirPrices2['index' + index + 'n' + n]
      } else {
        this.priceToDelete = ''
      }
      this.templateName = name
      this.templateClassifyid = f
      this.templateId = id2
      this.getByProduct(index, f, n)
      console.log(platformcode)
      this.GetList(index, n, platformcode)
      this.situationShow = 'index' + index + 'n' + n
      this.iconShow2 = product_classify_name + n
      this.dataUpdate(id2, f, index)
    },
    // 不同table
    dataUpdate(id2, f, index) {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        modeid: id2,
        classifyid: f,
      }
      fetch({
        url: "hcm/retrieve/retrieveSettingsList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.tableData = []
          this.totalNum = []
          this.tableData[index] = data.content
          this.totalNum[index] = data.totalElements
          this.tableData = { ...this.tableData }
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
  },
  computed: {

  },
  components: {
    pagination,
    preferentialSettings
  }
}
</script>

<style lang="scss">
#searchCriteriaSetting {
  .yellowStyle {
    padding: 8px;
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    margin-bottom: 16px;
  }

  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }

    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }

    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }

    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }

    .el-button--TheCustom:hover {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }

    .el-dialog__title {
      font-size: 14px;
    }
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #bda571;
    background: #bda571;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #666;
  }

  .el-radio__inner:hover {
    border-color: #bda571;
  }

  .searchCriteriaSettingpage {
    padding: 20px;
    margin-top: 10px;
    background-color: white;
    height: 100%;
    border-radius: 16px;
  }

  .iconDiv {
    width: 5px;
    background-color: #333333;
    margin-right: 10px;
    height: 21px;
    margin-top: 4px;
  }

  .mainBody {
    border-radius: 16px;
    // border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    margin-top: 10px;
    background-color: white;
  }

  .productDiv {
    font-size: 18px;
    width: calc(100% - 20px);
    border-bottom: 1px solid #ebeef5;
    height: 56px;
    line-height: 56px;
    padding-left: 20px;
    cursor: pointer;
  }

  .inputDiv {
    padding-right: 20px;
    width: calc(100% - 20px);
    padding-bottom: 15px;
    position: relative;
  }

  .inputDiv2 {
    padding-bottom: 15px;
    position: relative;
  }

  .qxButton {
    float: right;
    margin: 10px 20px 0 20px;
  }

  .tabStyle {
    padding-left: 13px;
    padding-right: 13px;
    width: 90px;
    padding: 0 20px;
    height: 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 40px;
    float: left;
    list-style: none;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    border: 1px solid rgba(128, 128, 128, 0.2);
    border-radius: 3px;
    cursor: pointer;
    position: relative;
    border-top: none;
    border-bottom: none;
    border-right: none;
  }

  .tabStyle:hover {
    color: #409EFF;
  }

  .clickTabStyle {
    padding-left: 13px;
    padding-right: 13px;
    width: 90px;
    padding: 0 20px;
    height: 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 40px;
    float: left;
    list-style: none;
    font-size: 14px;
    font-weight: 500;
    color: #409EFF;
    border: 1px solid rgba(128, 128, 128, 0.2);
    border-radius: 3px;
    cursor: pointer;
    position: relative;
  }

  .iconStyle {
    position: relative;
    top: -41px;
    right: -46px;
    font-size: 12px;
    width: 14px;
    height: 14px;
  }

  .iconStyle:hover {
    background-color: rgba(128, 128, 128, 0.6);
    border-radius: 50%;
    color: white;
    width: 14px;
    height: 14px;
  }

  .bigTab {
    border-bottom: 1px solid rgba(128, 128, 128, 0.2);
    height: 40px;
    margin-bottom: 20px;
    clear: both;
  }
}
</style>
